import { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { fixPropWarnings } from '../utils/fixPropWarnings';

interface SectionContainerProps {
  className?: string;
  fluid?: boolean;
  centered?: boolean;
  id?: string;
}

const Container = styled.div.withConfig(fixPropWarnings('centered', 'fluid'))<SectionContainerProps>`
  margin: 0 auto;
  text-align: ${(props) => (props.centered ? 'center' : 'inherit')};
  width: ${(props) => (props.fluid ? '100%' : 'calc(100% - 30px)')};
  max-width: 1280px;
  @media only screen and (min-width: 679px) {
    width: calc(100% - 60px);
  }
  /* Min-width 1340 because we break at 1280, so 1280 + 60px and this is our grid gutters */
  @media only screen and (min-width: 1340px) {
    width: 100%;
  }
`;

const SectionContainer = ({
  className,
  children,
  fluid,
  centered,
  id,
}: PropsWithChildren<SectionContainerProps>) => (
  <Container
    centered={centered}
    className={className}
    fluid={fluid}
    id={id}
  >
    {children}
  </Container>
);

export default SectionContainer;
